import { render, staticRenderFns } from "./KeyboardNew.vue?vue&type=template&id=6eb9b96e&scoped=true&"
import script from "./KeyboardNew.vue?vue&type=script&lang=js&"
export * from "./KeyboardNew.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardNew.vue?vue&type=style&index=0&id=6eb9b96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb9b96e",
  null
  
)

export default component.exports